import type { TOC } from '@ember/component/template-only'
import { StudentDashboardTile } from 'teacher-ui-client/components/tiles/student-dashboard'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { t } from 'ember-intl'
import {
  StudentDashboardActivityTable,
  type TableDataItem,
} from 'teacher-ui-client/components/tables/student-dashboard/activity-table'

interface Signature {
  Args: {
    data: TableDataItem[]
  }
}

export const FastPhonicsAssignmentsTile: TOC<Signature> = <template>
  <StudentDashboardTile
    data-test-student-dashboard-tile="assignments"
    class="m-3"
    @theme={{ThemeKeys.blue}}
    @title={{t "reporting.fastPhonics.studentDashboard.assignments.title"}}
    @icon="phosphor-book-fill"
  >
    <StudentDashboardActivityTable
      data-test-assignments-table
      exportable={{t "reporting.fastPhonics.studentDashboard.assignments.title"}}
      @theme={{ThemeKeys.blue}}
      @headerLabel={{t "reporting.fastPhonics.studentDashboard.assignments.recentActivityTitle"}}
      @subheaderLabel={{t "reporting.fastPhonics.studentDashboard.assignments.recentActivitySubtitle"}}
      @tableData={{@data}}
    />
  </StudentDashboardTile>
</template>
